import React from 'react';
import PropTypes from 'prop-types';

import AssetAvailability from '@components/shared/asset_availability/main';

const Availability = ({ asset, retrieveAsset }) => (
  <div className="availability-container">
    <AssetAvailability
      availabilityEnd={asset.attributes.availability_end}
      availabilityStart={asset.attributes.availability_start}
      selectedAssetKeys={new Set([asset.id])}
      updateAvailabilityStatus={retrieveAsset}
      activeCdnTracers={asset.attributes.activeCdnTracers}
    />
    <hr />
  </div>
);

Availability.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      activeCdnTracers: PropTypes.number,
      availability_end: PropTypes.string,
      availability_start: PropTypes.string,
    })
  }).isRequired,
  retrieveAsset: PropTypes.func.isRequired,
};

export default Availability;
